import EnclosureCommon from "./enclosureCommon";

export default class EnclosureBottom extends EnclosureCommon {

  constructor(isChild) {
    super(isChild);
    this.partId = 'enclosure_bottom';
    this.dbName = 'EnclosureBottom';
    this.partName = 'Enclosure Bottom';
    this.translateId = "visualizer.bathroom.shower.enclosure_bottom";
    this.canBeDisabled = false;
    this.isStoneFeature = true;
  }

}
